import "./App.css";

import {
  useMatcapTexture,
  useTexture,
  Center,
  Text3D,
  OrbitControls,
  useGLTF,
  MeshPortalMaterial,
  CameraControls,
  Environment,
  KeyboardControls,
  useKeyboardControls,
  useAnimations,
} from "@react-three/drei";
import * as THREE from "three";
import { useFrame, useLoader } from "@react-three/fiber";
import { useState, useEffect, useRef, useMemo } from "react";
import { easing } from "maath";
import {
  Debug,
  RigidBody,
  Physics,
  CylinderCollider,
  CuboidCollider,
  BallCollider,
  RapierRigidBody,
  useRapier,
  quat,
  vec3,
  euler,
} from "@react-three/rapier";

export default function Kitchen(props) {
  const lobsterRef = useRef();
  const stockpotsRef = useRef();
  const stockpotsRef2 = useRef();
  const stockpotsRef3 = useRef();
  const { rapier, world } = useRapier();
  const [rotateY, setRotateY] = useState(0);

  const sphere1 = useRef();

  const box = useRef();
  const [stateUp, setStateUp] = useState(false);
  const rigidBody = useRef < RapierRigidBody > null;

  const [hovered, setHovered] = useState(false);

  const map = useTexture("./maptexture1.jpg");
  const lobster = useGLTF("./models/lobster.glb");
  const stockpot = useGLTF("./models/stockpot.glb");

  const animations = useAnimations(stockpot.animations, stockpot.scene);

  const [subscribeKeys, getKeys] = useKeyboardControls();

  useFrame(() => {
    const { forward, backward } = getKeys();

    if (forward === true) lobsterJump();
    if (backward === true) lobsterDuck();
  });

  useFrame((state, delta) => {
    sphere1.current.rotation.y -= delta * 0.35;
    stockpotsRef.current.rotation.y += delta * 0.22;
    stockpotsRef.current.rotation.y += delta * 0.22;
  });

  // useFrame((state, delta) => {
  //   if (stockpotsRef.current) {
  //     stockpotsRef.current.setAngvel({ x: 0, y: 1, z: 0 }, true);
  //   }
  // });

  useFrame((state, delta) => {
    if (!stockpotsRef.current) return;

    const targetSpeed = 0.32;

    const acceleration = 1.0;

    const current = stockpotsRef.current.angvel();

    const newY = THREE.MathUtils.lerp(
      current.y,
      targetSpeed,
      1 - Math.exp(-acceleration * delta)
    );

    stockpotsRef.current.setAngvel({ x: 0, y: newY, z: 0 }, true);
  });

  useEffect(() => {
    document.body.style.cursor = hovered ? "pointer" : "auto";
  }, [hovered]);

  useEffect(() => {
    const lobsterPosition = lobsterRef.current.translation();

    console.log(lobsterPosition.y);
    if (lobsterPosition.y >= 0.2) {
      lobsterRef.current.resetForces(true);
    }
  }, [lobsterRef.current]);


const MIN_Y = -2.25; 
const MAX_Y = -1.69;  


const lobsterJump = () => {
  const body = lobsterRef.current;
  const mass = body.mass();
  const y = body.translation().y;

  // If already too high, do nothing
  if (y >= MAX_Y) return;

  // Stronger upward impulse
  body.applyImpulse({ x: 0, y: 0.2 * mass, z: 0 }, true);
};

const lobsterDuck = () => {
  const body = lobsterRef.current;
  const mass = body.mass();
  const y = body.translation().y;

  // If already too low, do nothing
  if (y <= MIN_Y) return;

  // Stronger downward impulse
  body.applyImpulse({ x: 0, y: -0.2 * mass, z: 0 }, true);
};




  function toggleDirection() {
    setStateUp(true);
    setStateUp(false);
  }

  const collisionEnter = () => {
    console.log("enter collision");
    props.setPanCount(1);
  };

  return (
    <>
      <OrbitControls
        minDistance={5}
        maxDistance={6}
        target={[-0.7, -0.8, -2.2]}
        enablePan={false}
        enableRotate={false}
      />
      <Environment preset="apartment" />

      <Physics>
        <RigidBody
          key={"1b"}
          type="dynamic"
          gravityScale={0}
          restitution={0}
          friction={0.7}
          canSleep={false}
          colliders="trimesh"
          ref={stockpotsRef}
          position={[9.25, -2, 9.8]} 
          linearDamping={5}
  angularDamping={2}
       >
          <primitive object={stockpot.scene} scale={0.3} />
        </RigidBody>

        <RigidBody
          canSleep={false}
          gravityScale={0}
          type="dynamic"
          position={[-1.5, -1.9, -5]}
          rotation={[20.15, -80.05, 0.09]}
          ref={lobsterRef}
          onCollisionEnter={collisionEnter}
        >
          <CylinderCollider
            position={[0.38, 0.2, 0.5]}
            args={[1, 0.79]}
            rotation={[-8, -79.2, 28.5]}
            mass={5}
          />

          <primitive
            object={lobster.scene}
            onClick={toggleDirection}
            scale={0.5}
          />
        </RigidBody>
        <Text3D
          className="upDownButton"
          font="./fonts/Inconsolata_Regular.json"
          size={0.3}
          height={0.1}
          curveSegments={20}
          bevelEnabled
          bevelThickness={0.0008}
          bevelSize={0.03}
          bevelOffset={0}
          bevelSegments={10}
          rotation-x={-0.1}
          rotation-y={0.1}
          rotation-z={0.03}
          position={[0.8, -2.6, -5]}
          onClick={lobsterJump}
          onPointerOver={() => setHovered(true)}
          onPointerOut={() => setHovered(false)}
        >
          {" "}
          UP
          <meshStandardMaterial metalness={0.2} roughness={0} color={"black"} />
        </Text3D>
        <Text3D
          font="./fonts/Inconsolata_Regular.json"
          size={0.3}
          height={0.1}
          curveSegments={20}
          bevelEnabled
          bevelThickness={0.0008}
          bevelSize={0.03}
          bevelOffset={0}
          bevelSegments={10}
          rotation-x={-0.1}
          rotation-y={0.1}
          rotation-z={0.03}
          position={[0.8, -3, -5]}
          onClick={lobsterDuck}
          onPointerOver={() => setHovered(true)}
          onPointerOut={() => setHovered(false)}
        >
          DOWN
          <meshStandardMaterial metalness={0.2} roughness={0} color={"black"} />
        </Text3D>
        <mesh position={[-1.9, 0, -1.9]} rotation={[0, 0, 0]} ref={sphere1}>
          <sphereGeometry args={[80, 64, 64]} />
          <meshStandardMaterial map={map} side={THREE.BackSide} />
        </mesh>
      </Physics>
    </>
  );
}
